import {
   Component,
   ComponentFactory,
   ComponentFactoryResolver,
   ComponentRef,
   EventEmitter,
   Input,
   OnChanges,
   OnInit,
   Output,
   SimpleChanges,
   ViewChild,
} from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import _ from 'lodash';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { IDirectoryColumnEditComponent } from 'src/app/samwebDescription/samweb/directory/directory-column-edit-component';
import { OrganisationEntryRemoteDto } from 'src/generated/swagger';
import { ComponentHostDirective } from '../../general-directives/component-host.directive';

@Component({
   selector: 'samweb-directory-column-edit',
   templateUrl: './directory-column-edit.component.html',
   styleUrls: ['./directory-column-edit.component.scss'],
})
export class DirectoryColumnEditComponent implements OnInit, OnChanges {
   @Input()
   public column: DirectoryColumn;
   @Input()
   public icon: IconDefinition;
   @Input()
   public header: string;
   @Input()
   public value: string | number | boolean | Date;
   @Input()
   public valueOriginal: string | number | boolean | Date;
   @Input()
   public valueUpdated: string | number | boolean | Date;
   @Input()
   public isComparatorActive: boolean;
   @Input()
   public isFocused: boolean;
   @Input()
   public isDisabled: boolean;
   @Input()
   public orgdata: OrganisationEntryRemoteDto[];
   @Input()
   public orgUnit: string;

   @Output()
   public valueChanged = new EventEmitter();
   @Output()
   public updateUnchangedValues = new EventEmitter();
   @Output()
   public takeMine = new EventEmitter();
   @Output()
   public takeOther = new EventEmitter();

   private componentRef: ComponentRef<IDirectoryColumnEditComponent>;

   @ViewChild(ComponentHostDirective, { static: true })
   public layoutHost: ComponentHostDirective;

   constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

   ngOnChanges(changes: SimpleChanges): void {
      if (changes?.value?.previousValue !== changes?.value?.currentValue) {
         if (!_.isNil(this.componentRef?.instance?.value)) {
            this.componentRef.instance.value = changes.value.currentValue;
         }
      }
      if (changes?.valueOriginal?.previousValue !== changes?.valueOriginal?.currentValue) {
         if (!_.isNil(this.componentRef?.instance?.valueOriginal)) {
            this.componentRef.instance.valueOriginal = changes.valueOriginal.currentValue;
         }
      }
      if (changes?.valueUpdated?.previousValue !== changes?.valueUpdated?.currentValue) {
         if (!_.isNil(this.componentRef?.instance?.valueUpdated)) {
            this.componentRef.instance.valueUpdated = changes.valueUpdated.currentValue;
         }
      }
      if (changes?.isComparatorActive?.previousValue !== changes?.isComparatorActive?.currentValue) {
         if (!_.isNil(this.componentRef?.instance?.isComparatorActive)) {
            if (changes.isComparatorActive.currentValue && this.value === this.valueOriginal) {
               this.updateUnchangedValues.emit(this.valueUpdated);
            } else {
               this.componentRef.instance.isComparatorActive = changes.isComparatorActive.currentValue;
            }
         }
      }
   }

   ngOnInit(): void {
      const layoutFactory: ComponentFactory<IDirectoryColumnEditComponent> = this.componentFactoryResolver.resolveComponentFactory(
         this.column.columnTyp.editComponent
      );

      try {
         this.layoutHost.viewContainerRef.clear();
      } catch {}

      this.componentRef = this.layoutHost.viewContainerRef.createComponent<IDirectoryColumnEditComponent>(layoutFactory);
      this.componentRef.instance.icon = this.icon;
      this.componentRef.instance.header = this.header;
      this.componentRef.instance.value = this.value;
      this.componentRef.instance.valueOriginal = this.valueOriginal;
      this.componentRef.instance.valueUpdated = this.valueUpdated;
      this.componentRef.instance.isComparatorActive = this.isComparatorActive;
      this.componentRef.instance.isFocused = this.isFocused;
      this.componentRef.instance.orgdata = this.orgdata;
      this.componentRef.instance.orgUnit = this.orgUnit;
      this.componentRef.instance.valueChanged = this.valueChanged;
      this.componentRef.instance.takeMine = this.takeMine;
      this.componentRef.instance.takeOther = this.takeOther;
      this.componentRef.instance.isDisabled = this.isDisabled;
   }
}
